import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TaskOffCanvas from '../../common/OffCanvas';
import BillingRateAddUpdate from "./BillingRateAddUpdate";
import { updateAccountBillingRate, updateAccountBillingRateId } from './billingRateSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import clsx from 'clsx';
import { Dropdown } from 'react-bootstrap';
import {
    getAccountBillingRateList, getAccountBillingRateByAccountProjectEmployeeId, getAccountBillingRateByAccountProjectTaskId, getAccountBillingRatesByAccountEmployeeId,
    updateAccountProjectRoleId, updateAccountProjectEmployeeId, updateAccountWorkTypeId, updateIsLoading, updateAccountProjectTaskId,
    deleteAccountBillingRate, updateAccountEmployeeId, updateAccountEmployeeIdFromSummary, updateSorting
} from '../billing/billingRateSlice';
import { ShowSwal, ShowSwalWithBillingDetail, ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { ShowToast } from '../../common/Toastr';
import moment from 'moment';
import Select, { StylesConfig } from 'react-select';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, formatHoursOff, headerDropDownStyles, getValueFromResource } from '../../common/timeLiveFunction';
import Loader from '../../common/Loader';
import fetchAPI from '../../common/fetchAPI';

const AccountBillingRate = (props: any) => {
    const { state } = useLocation();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    // const [hoveredColumn, setHoveredColumn] = useState(null);
    const { AccountProjectRoleId, AccountProjectEmployeeId, SystemBillingRateTypeId, Id, ProjectName, AccountEmployeeId, AccountProjectTaskId, TaskName } = state;
    const { billingRateList, projectBillingRateType, accountWorkType, accountBillingRateId, accountProjectRoleId, accountProjectEmployeeId, accountWorkTypeId, accountProjectTaskId, accountEmployeeId, employeeName, shortName, profilePictureColor, isReload,
        isLoading, sortOrder, sortColumn } = useAppSelector((state) => state.billingRate);
        const {  } = useAppSelector((state) => state.billingRate);
    const { decimalPlaces, accountBaseCurrencyId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat,IsEmployeeList,IsEmployeeEdit,IsEmployeeDelete,IsEmployeeAdd } = useAppSelector((state) => state.globalState)
      
    useEffect(() => {
        dispatch(updateIsLoading(true));
        GetAccountWorkType().then((result) => {
            let getAccountWorkTypeId = result[0].AccountWorkTypeId;
            if (SystemBillingRateTypeId == 2) {
                //AccountProjectRole
                dispatch(updateAccountProjectRoleId({ "AccountProjectRoleId": AccountProjectRoleId, "AccountWorkTypeId": getAccountWorkTypeId }));
                dispatch(getAccountBillingRateList());
            } else if (SystemBillingRateTypeId == 3) {
                //AccountProjectEmployee
                if (accountWorkTypeId === 0) {
                    dispatch(updateAccountProjectEmployeeId({ "AccountProjectEmployeeId": AccountProjectEmployeeId, "AccountWorkTypeId": getAccountWorkTypeId }));
                }
                dispatch(getAccountBillingRateByAccountProjectEmployeeId(AccountEmployeeId));
            } else if (SystemBillingRateTypeId == 4) {
                //AccountProjectTask
                if (accountWorkTypeId === 0) {
                    dispatch(updateAccountProjectTaskId({ "AccountProjectTaskId": AccountProjectTaskId, "AccountWorkTypeId": getAccountWorkTypeId }));
                }
                dispatch(getAccountBillingRateByAccountProjectTaskId());
            }
            else if (SystemBillingRateTypeId === 1) {
                //AccountProjectTask
                if (accountWorkTypeId === 0) {
                    dispatch(updateAccountEmployeeId({ "AccountEmployeeId": AccountEmployeeId, "AccountWorkTypeId": getAccountWorkTypeId }));
                } else {
                    dispatch(updateAccountEmployeeIdFromSummary(AccountEmployeeId))
                }
                dispatch(getAccountBillingRatesByAccountEmployeeId());
            }
        })
    }, [isReload, accountWorkTypeId]);

    const GetAccountWorkType = async () => {
        try {
            const response = await fetchAPI(`api/V2/BillingRates/GetAccountWorkType/0`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
        catch (error) {

        }
    }


    const generalObject = {
        
        // "name": t("Billing Rate"),
        "name": (accountBillingRateId === 0 ? getValueFromResource('Add ',dispatch,t) : getValueFromResource('Update ', dispatch, t)) + ' ' + getValueFromResource('Billing Rate', dispatch,t),
        "width": "600px",
        "componentName": <BillingRateAddUpdate obj={{
            "SystemBillingRateTypeId": SystemBillingRateTypeId,
            "AccountWorkTypeId": accountWorkTypeId,
            "Id": Id
        }} />
    }
    const onDeleteAccountProjectRate = (id: number) => {
        ShowSwalWithConfirmation(t('Are you sure you want to delete this record?'), "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteAccountBillingRate(id)).then((result) => {
                        Number(result.payload.Id) > 0 ?
                            ShowToast('Success', 'Record deleted successfully', "success", "toast-top-right") :
                            ShowToast('Error', 'Record deletion failed. Dependent record exists', "error", "toast-top-right");
                    }).catch((error) => {
                    })
                }
            })
            .catch((error) => {
            });
    }

    const onUpdateAllRecords = (id: number) => {

    const selectedItem = billingRateList.find(item => item.AccountBillingRateId === id);
    if (!selectedItem) {
        ShowToast('Error', 'Item not found!', 'error', 'toast-top-right');
        return;
    }


    const htmlContent = `
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; text-align: left;">
        <div><strong>Billing Rate:</strong> ${selectedItem.BillingRateCurrencyCode}${FormatInvoiceDecimalNumber(cultureInfoName.toString(), selectedItem.BillingRate, decimalPlaces)}</div>
        <div><strong>Employee Rate:</strong> ${selectedItem.EmployeeRateCurrencyCode}${FormatInvoiceDecimalNumber(cultureInfoName.toString(), selectedItem.EmployeeRate, decimalPlaces)}</div>
        <div><strong>Start Date:</strong> ${formatDateWithDateAndMonthName(selectedItem.StartDate, cultureInfoName.toString())}</div>
        <div><strong>End Date:</strong> ${formatDateWithDateAndMonthName(selectedItem.EndDate, cultureInfoName.toString())}</div>
    </div>
`;

        let objectAdd = {
            SystemBillingRateTypeId: selectedItem.SystemBillingRateTypeId,
           AccountProjectEmployeeId: accountProjectEmployeeId,
            AccountProjectRoleId: accountProjectRoleId,
            AccountEmployeeId: accountEmployeeId,
            AccountProjectTaskId: accountProjectTaskId,
            BillingRateCurrencyId: selectedItem.BillingRateCurrencyId,
            BillingRate: selectedItem.BillingRate,
            EmployeeRate: selectedItem.EmployeeRate,
            EmployeeRateCurrencyId: selectedItem.EmployeeRateCurrencyId,
            StartDate: moment(selectedItem.StartDate).format(dateInsertionFormat),
            EndDate: moment(selectedItem.EndDate).format(dateInsertionFormat),
            AccountWorkTypeId: accountWorkTypeId,
            IsBillingRateUpdate: true,
            AccountBaseCurrencyId: accountBaseCurrencyId    
        }

        ShowSwalWithBillingDetail('Update all records in this date range?', htmlContent, 'Yes, Proceed')
            .then((result) => {
                if (result === true) {
                    dispatch(updateAccountBillingRateId(id))                   
                    dispatch(updateAccountBillingRate(objectAdd)).then((result) => {
                            if (Number(result.payload.id) > 0) {
                                ShowToast('Success', 'Record updated successfully', "success", "toast-top-right");
                            } else {
                                ShowToast('Error', 'Record updated failed', "error", "toast-top-right");
                            }                           
                        }).catch((error) => {
                            console.error(error);                            
                        });
                }
            });

};


    const onChangeWorkType = (data: any) => {
        dispatch(updateAccountWorkTypeId(data.value));
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn
        }
        dispatch(updateSorting(objects));
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Biling Rate List')} */}
                        {getValueFromResource('Biling Rate List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        {(SystemBillingRateTypeId == 3 || SystemBillingRateTypeId == 4 || SystemBillingRateTypeId == 1) &&
                            <>
                                <div className="d-flex align-items-center">
                                    <Select
                                        value={accountWorkType.filter((x: any) => x.value === accountWorkTypeId)}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        name="accountWorkType"
                                        onChange={(e) => onChangeWorkType(e)}
                                        options={accountWorkType}
                                        styles={headerDropDownStyles}
                                    />
                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            </>
                        }
                         {/* {IsEmployeeAdd && */}
                        <button
                            id="kt_OffCanvas"
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => { dispatch(updateAccountBillingRateId(0)) }}
                        >
                            <i className="bi bi-pencil-square fs-5 me-1"></i>
                            {/* {t('Add Billing Rate')} */}
                            {getValueFromResource('Add Billing Rate',dispatch, t)}
                        </button> 
                        {/* } */}
                    </div>
                </div>
                <div className='mt-3'>
                    {SystemBillingRateTypeId != 4 &&
                        <div className="d-flex align-items-center mt-2 mb-2">
                            <a className="text-muted fw-bold me-2 fs-2">{ProjectName}</a>
                        </div>
                    }
                    {SystemBillingRateTypeId == 4 &&
                        <div className="d-flex align-items-center mt-2 mb-2">
                            <a className="text-muted fw-bold me-2 fs-2">{TaskName}</a>
                        </div>
                    }
                    <div className="breadcrumb breadcrumb-separatorless fs-7 my-0">
                        <a className="text-gray-400">
                            {/* {t("Billing Rate Type")} */}
                            {getValueFromResource('Billing Rate Type',dispatch, t)}
                            </a>
                        <span className="breadcrumb-item"><span className="bullet bg-gray-400 w-5px h-2px"></span></span>
                        {projectBillingRateType.length > 0 && <span className="breadcrumb-item text-muted me-2 fs-6">{projectBillingRateType.filter((x: any) => x.SystemProjectBillingRateTypeId === SystemBillingRateTypeId)[0].SystemProjectBillingRateType}</span>}
                    </div>
                    {(SystemBillingRateTypeId == 3 || SystemBillingRateTypeId == 1) &&
                        <div className="d-flex flex-wrap fs-7 mt-2 mb-4 pe-2">
                            <div className='d-flex align-items-center flex-shrink-0 me-1'>
                                <div className='symbol-group symbol-hover flex-shrink-0 me-1'>
                                    <div className="symbol symbol-circle symbol-35px">
                                        <div className="symbol-label fw-bold text-inverse-warning" style={{ backgroundColor: profilePictureColor != '' ? profilePictureColor : '#512da8' }}>
                                            {shortName}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a className="text-muted fs-5 fw-bold mt-2">{employeeName}</a>
                        </div>
                    }
                </div>
                {/* <div className='card-body py-3 mt-2'> */}
                <div className='card-Report-body py-3 mt-2'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className='thHeading align-middle'>
                                    <th style={{ width: '25%' }}
                                    // onMouseEnter={() => handleMouseEnter(0)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Billing Rate")} */}
                                        {getValueFromResource('Billing Rate',dispatch, t)}
                                        {sortColumn === 'BillingRate' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingRate") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingRate") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 0 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "BillingRate") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "BillingRate") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '25%' }}
                                    // onMouseEnter={() => handleMouseEnter(1)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Employee Rate")} */}
                                        {getValueFromResource('Employee Rate',dispatch, t)}
                                        {sortColumn === 'EmployeeRate' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EmployeeRate") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EmployeeRate") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 1 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EmployeeRate") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EmployeeRate") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '25%' }}
                                    // onMouseEnter={() => handleMouseEnter(2)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("Start Date")} */}
                                        {getValueFromResource('Start Date',dispatch, t)}
                                        {sortColumn === 'StartDate' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "StartDate") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "StartDate") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 2 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "StartDate") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "StartDate") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '25%' }}
                                    // onMouseEnter={() => handleMouseEnter(3)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t("End Date")} */}
                                        {getValueFromResource('End Date',dispatch, t)}
                                        {sortColumn === 'EndDate' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "EndDate") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "EndDate") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 3 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "EndDate") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "EndDate") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th className='min-w-50px'>{t("")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {billingRateList.length > 0 && billingRateList.map((item: any) => {
                                    return (
                                        <tr key={item.AccountBillingRateId}>
                                            <td>
                                                <a className='text-dark fw-bold d-block'>
                                                    {/* {`${item.BillingRateCurrencyCode} ${item.BillingRate.toFixed(2)}`} */}
                                                    {`${item.BillingRateCurrencyCode} ${FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BillingRate, decimalPlaces)}`}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-dark fw-bold d-block'>
                                                    {/* {`${item.EmployeeRateCurrencyCode} ${item.EmployeeRate.toFixed(2)}`} */}
                                                    {`${item.EmployeeRateCurrencyCode} ${FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.EmployeeRate, decimalPlaces)}`}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-dark d-block'>
                                                    {/* {moment.parseZone(item.StartDate).format('DD MMM yy')} */}
                                                    {formatDateWithDateAndMonthName(item.StartDate, cultureInfoName.toString())}
                                                </a>
                                            </td>
                                            <td>
                                                <a className='text-dark d-block'>
                                                    {/* {moment.parseZone(item.EndDate).format('DD MMM yy')} */}
                                                    {formatDateWithDateAndMonthName(item.EndDate, cultureInfoName.toString())}
                                                </a>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {t("More")}
                                                        {getValueFromResource('More',dispatch, t)}
                                                        data-tooltip-place="bottom"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                       
                                                          {/* {IsEmployeeEdit && <> */}
                                                          <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                id="kt_OffCanvas"
                                                                className="menu-item me-lg-0"
                                                                onClick={() => { dispatch(updateAccountBillingRateId(item.AccountBillingRateId)) }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}
                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        
                                                         <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item                                                              
                                                              className="menu-item me-lg-0"
                                                               onClick={() => { onUpdateAllRecords(item.AccountBillingRateId) }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">                                                                    
                                                                    {getValueFromResource('Update Range',dispatch, t)}
                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        {/* </>
                                                          } */}
                                                           {/* {IsEmployeeDelete &&
                                                            <> */}
                                                        <div className='separator mb-1 mt-1 opacity-75'></div>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0"
                                                                onClick={() => { onDeleteAccountProjectRate(item.AccountBillingRateId) }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title delete-menu custom-menu-fontsize">
                                                                    {/* {`${t('Delete')}`} */}
                                                                    {getValueFromResource('Delete',dispatch, t)}
                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>  
                                                        {/* </>
                                                        } */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {billingRateList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <TaskOffCanvas obj={generalObject} />
        </>
    )
}

export default AccountBillingRate